module.exports = {
    time: {
        title: '网络研讨会',
        date:'日期:12月10日',
        time:'时间:10:00 - 16:45 '
    },
    title:{
        p1:'会议简介',
        p2:'会议组织',
        p3:'主办',
        p4:'协办',
        p5:'承办',
        p6:'大会媒体',
    },
    meeting_content:{
        p1:'半导体是近年来最具影响力的先导性技术。它是国家综合科技实力的重要标志，在人工智能、5G通讯、汽车、电子、区块链等领域发挥关键作用，支撑国家的核心竞争力，足以影响社会经济发展。在「十四五」蓝图上，第三代半导体更成为重中之重的发展战略。与此同时，「十四五」亦提到要建设粤港澳大湾区成为国际创新科技中心，打造引领核心技术突破的全球科技创新高地。 ',
        p2:'在「十四五」科创规划和粤港澳大湾区建设大背景下，当前的大湾区正迎来先进半导体的黄金发展期。大湾区能发挥创新源头、人才驿站、合作桥梁和中介平台作用，可以大力支撑国家半导体发展。为促进国家半导体产业技术的升级发展，探讨如何发挥粤港澳大湾区的优势，打造具有特色的大湾区先进半导体产业 高地，香港应用科技研究院将于2021年12月10日组织举办首届“先进半导体创新发展论坛”。本次论坛主题为“还看大湾区优势”，聚焦探讨如何把握粤港澳大湾区建设的历史机遇，装备大湾区半导体产业链上下游企业建立可持续的创新生态环境，加强粤港澳在科研上的充分协作，参与国家半导体发展战略，推 动大湾区成为国际创新科技中心。本次论坛将邀请香港、内地及海外知名专家进行深入讨论，为推进粤港澳大湾区内先进半导体产业发展提供多角度观点及思路。',
        p3:'会议将分为上午的主题演讲，及下午的两个技术分会 -- 第三代半导体及半导体制造与检测, 含多场的演讲与最后的圆桌论坛。已确定出席发言的领导与专家包括:'
    },
    guest_info:{
        g1:{name:'曹健林',position:'主&nbsp;&nbsp;&nbsp;任&nbsp;&nbsp;&nbsp;&nbsp;(科技部原副部长、季华实验室理事长)'},
        g2:{name:'杨&nbsp;&nbsp;&nbsp;军',position:'副厅长&nbsp;&nbsp;&nbsp;&nbsp;(广东省科学技术厅副厅长)'},
        g3:{name:'陈南翔',position:'博&nbsp;&nbsp;&nbsp;士&nbsp;&nbsp;&nbsp;&nbsp;(紫光集团联席总裁、长江存储执行董事长)'},
        g4:{name:'郑光廷',position:'教&nbsp;&nbsp;&nbsp;授&nbsp;&nbsp;&nbsp;&nbsp;(香港科技大学工学院院长、智能芯片与系统研发中心总监)'},
        g5:{name:'刘&nbsp;&nbsp;&nbsp;胜',position:'教&nbsp;&nbsp;&nbsp;授&nbsp;&nbsp;&nbsp;&nbsp;(武汉大学动力与机械学院院长)'},
        g6:{name:'陈&nbsp;&nbsp;&nbsp;敬',position:'教&nbsp;&nbsp;&nbsp;授&nbsp;&nbsp;&nbsp;&nbsp;(香港科技大学电子及计算机系讲座教授)'},
        g7:{name:'钟树鸿',position:'教&nbsp;&nbsp;&nbsp;授&nbsp;&nbsp;&nbsp;&nbsp;(香港城市大学电子工程学系讲座教授)'},
        g8:{name:'李&nbsp;&nbsp;&nbsp;明',position:'博&nbsp;&nbsp;&nbsp;士&nbsp;&nbsp;&nbsp;&nbsp;(ASM太平洋科技集团)'},
        g9:{name:'戴小平',position:'先&nbsp;&nbsp;&nbsp;生&nbsp;&nbsp;&nbsp;&nbsp;(湖南国芯半导体科技有限公司总经理)'},
        g10:{name:'蒋金波',position:'先&nbsp;&nbsp;&nbsp;生&nbsp;&nbsp;&nbsp;&nbsp;(香港应用科技研究院高级经理)'}
    },
    explain:{
        p1:'更多的会议内容及',
        p2:'讲师资料,',
        p3:'将会陆续公布。',
        p4:'欢迎扫码关注,',
        p5:'并及早注册, ',
        p6:'免费参会。',
        p7:'会议全程将以普通话进行。'
    },
    company:{
        c1:{title:'香港应用科技研究院 ',content:'香港应用科技研究院 (应科院) 由香港特别行政区政府于2000年成立，其使命是透过应用科技研究提升香港的竞争力。应科院的主要科技研发领域可归纳于五个技术部门，包括：人工智 能及大数据、通讯技术、网络安全、密码及可信技术、集成电路及系统、物联网感测技术。而技术研发主要应用在五项重点范畴：智慧城市、金融科技、智能制造、数码健康科技和专用集成电路。 '},
        c2:{title:'京港学术交流中心 ',content:'「京港学术交流中心」由杨振宁教授提议，于1985年3月在香港注册成立，是一个非盈利的教育科技交流服务机构，旨在促进内地与香港以至海外间开展学术、科技交流和科技产业合作之活动，提供咨询、联络及资助等服务。',content2:'「京港学术交流中心」受中国内地及香港教育与科技单位委托，并得到中央人民政府驻香港特别行政区联络办公室（中联办）的支持。现有董事局成员包括：国家科技部、教育部、科学院、社会科学院、医学科学院、科学技术协会、自然科学基金委员会，以及中联办等机构。'},
        c3:{title:'季华实验室 ',content:'季华实验室（先进制造科学与技术广东省实验室）是广东省委、省政府启动的首批4家广东省实验室之一。全国政协教科卫体委员会副主任、科技部原副部长曹健林担任首任理事长和主任。',content2:'季华实验室面向世界科技前沿、面向国民经济主战场，围绕国家和广东省重大需求，集聚、整合国内外优势创新资源，打造先进制造科学与技术领域国内一流、国际高端的战略科技创新平台。部署了机器人及其关键技术、半导体技术与装备、高端医疗装备、新型显示装备、 先进遥感装备、增材制造、新材料新器件研究、微纳制造等八个研究方向。力争成为本领域的国家实验室。'},
        c4:{title:'国家专用集成电路系统工程技术研究中心香港分中心',content:'2012年6月，香港应用科技研究院获得科技部批准，成立国家专用集成电路系统工程技术研究中心香港分中心(工程分中心)。这是首个国家工程技术研究中心的香港分中心。工程分中 心围绕微电子和集成电路与系统，在第三代半导体、视觉智能和无线物联网芯片三个方向上开展科学研究、工程转化和人才培养等工作。工程分中心还与位于东南大学的国家专用集成 电路系统工程技术研究中心 (主中心) 开展密切合作，旨在善用双方各自优势，共同开发世界级的集成电路及应用系统，提升内地与香港集成电路业的竞争力。 '},
        c5:{title:'国家专用集成电路系统工程技术研究中心',content:'国家专用集成电路系统工程技术研究中心组建于1992年，主管部门为教育部、江苏省科技厅，依托于东南大学。1995年通过国家科技部组织的验收，历次通过国家科技部评估， 2000年、2007年、2011年分别获国家科技部再建设支持。工程中心设有实验室、研究所及产业化平台, 不断跟踪国际先进的集成电路发展趋势，聚焦集成电路的高能效设计，在低 功耗和低损耗的设计理论和关键技术方面取得了突出成果。立足创新，充分发挥自身的特色与优势，抓住机遇，迎接挑战，以高技术产业化为龙头，实现科学研究、技术开发与学科建设、队伍建设、人才培养的互动发展。 '},
        c6:{title:'雅时国际商讯 ',content:'雅时国际商讯（ACT International）成立于1998年，为高速增长的中国市场中广大高技术行业服务。ACT通过它的一系列产品－包括杂志和网上出版物、培训、会议和活动－为跨国公 司及中国企业架设了拓展中国市场的桥梁。ACT的产品包括多种技术杂志和相关的网站，以及各种技术会议，服务于机器视觉设计、电子制造、激光/光电子、射频/微波、化合物半导体 、半导体制造、洁净及污染控制、电磁兼容等领域的约二十多万专业读者及与会者。ACT亦是若干世界领先技术出版社及展会的销售代表。ACT总部在香港，在北京、上海、深圳和武汉设有办事处。'}
    }

}


// WEBPACK FOOTER //
// ./src/lang/zh.js